export default __webpack_public_path__ + "static/media/POD-18.e0ab3a21.jpg";